import * as React from "react";

function SvgWorkspace(props) {
  return (
    <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18.735}
        height={16.515}
        {...props}
      >
        <path
          data-name="Path 43226"
          d="M18.735 7.641h-6.934v-1.04h2.524V4.437h.024V0H4.461v3.272h-.024v3.329h2.524v1.04H-.001v8.879h6.719v-5.55h5.271v5.55h6.72v-5.55h.025zM5.626 1.165h7.558v2.107H5.626zm-.024 4.271v-1h7.559v1H5.602zm5.034 1.165v.941h-2.51v-.941zM5.554 15.35h-4.39v-1.6h4.39zm0-2.769h-4.39V10.97h4.39zm1.165-2.776H1.164v-1h16.405v1H6.719zm10.825 5.545h-4.39v-1.6h4.39zm0-2.769h-4.39V10.97h4.39z"
        />
      </svg>
    </span>
  );
}

export default SvgWorkspace;
